<script lang="ts">
	import { getTranslate, T } from '@tolgee/svelte';
	import { customer } from '$lib/store/customer.store';
	import { MetaHead } from '@thearc-hq/ui-kit';
	import { page } from '$app/stores';
	import TitleHeading from '../Heading/TitleHeading.svelte';
	import EditSettingsCard from '../Card/EditSettingsCard.svelte';
	import CustomerNoOrders from './CustomerNoOrders.svelte';
	import { resolveRoute } from '$app/paths';
	import OrderLineItemList from '../Order/List/OrderLineItemList.svelte';
	import type { Order, OrderLine } from '$lib/types/Order/order';

	export let orders: Array<Order> = [];

	$: orderLineItems = orders.flatMap<OrderLine>((order) => {
		return order.lineItems.edges.map((edge) => ({ ...edge.node, order }) as OrderLine);
	});

	const { t } = getTranslate();

	let greetingSymbol: string = $customer?.firstName || $customer?.lastName ? ', ' : '!';
	let greetingName: string =
		$customer?.firstName || $customer?.lastName
			? `${$customer?.firstName ?? ''} ${$customer?.lastName ?? ''}!`
			: '';
</script>

<MetaHead title={$t('seo.title.customer.profile.default')} />
{#if $customer}
	<div class="flex flex-col gap-7 divide-y-[1px] divide-solid divide-dark-quaternary">
		<TitleHeading title={$t('customer.overview.title')} />
		<div class="space-y-2 pt-6">
			<h5 class="w-full break-all ph-no-capture">
				<T keyName="hello" />
				{greetingSymbol}
				{greetingName}
			</h5>
			<p class="text-p-16">
				<T keyName="customer.overview.description" />
			</p>
		</div>
		<div class="space-y-8 pt-6">
			<div class="flex flex-row justify-between space-4">
				<h3>
					<T keyName="customer.overview.lastOrders" />
				</h3>
				<a
					href={resolveRoute('/[locale]-[country]/customer/orders', $page.params)}
					class="cursor-pointer rounded text-accent-primary whitespace-nowrap px-4 -mr-4 py-2 hover:underline text-h-12"
				>
					<T keyName="customer.overview.allOrders" />
				</a>
			</div>
			{#if orders.length > 0}
				<OrderLineItemList {orderLineItems} />
			{:else}
				<CustomerNoOrders />
			{/if}
		</div>
		<div class="flex flex-col pt-6 ph-no-capture">
			<EditSettingsCard
				titleTolgeeKey="address.contactData"
				contentItems={[`${$customer.firstName ?? ''} ${$customer.lastName}`, $customer?.email]}
				editLink={resolveRoute('/[locale]-[country]/customer/profile', $page.params)}
				changePasswordLink={resolveRoute(
					'/[locale]-[country]/customer/profile/changePassword',
					$page.params
				)}
			/>
		</div>
	</div>
{/if}
